import {gql} from "@apollo/client";
import {query} from "../../lib/apollo";

export async function searchProgramSets(limit: number, search: string) {
    const q = gql`
      query q ($input: HpProgramSetsInput!) {
        hpProgramSets(input: $input) {
            count
            items {
                id
                name
                school
                broker
            }
        }
      } 
    `;

    const variables = {
        input: {
            limit,
            skip: 0,
            search,
        }
    };

    const response = await query(q, variables);
    if (!response || !response.hpProgramSets) {
        return {count: 0, programSets: []};
    }

    return {count: response.hpProgramSets.count, programSets: response.hpProgramSets.items};
}
